import { CreditCard, MapPin, Receipt } from 'lucide-react'
import * as React from 'react'
import { ComponentType } from 'react'
import { useCustomerPortal } from '../hooks'

type BillingInformationSectionProps = {
  workspaceId: string
}

export const BillingInformationSection = ({ workspaceId }: BillingInformationSectionProps) => {
  return (
    <div>
      <div className="pb-4 text-lg font-semibold">Preferences</div>
      <div className="flex flex-col gap-6 sm:flex-row">
        <PaymentActionCard
          workspaceId={workspaceId}
          Icon={CreditCard}
          title="Payment Method"
          description="Add, remove, or update your payment method"
        />
        <PaymentActionCard
          workspaceId={workspaceId}
          Icon={MapPin}
          title="Billing Information"
          description="Edit your name, billing email, address, and tax information"
        />
        <PaymentActionCard
          workspaceId={workspaceId}
          Icon={Receipt}
          title="Invoice History"
          description="Download invoices and view your complete billing history"
        />
      </div>
    </div>
  )
}

type PaymentActionCardProps = {
  Icon: ComponentType<{ className?: string }>
  title: string
  description: string
  workspaceId: string
}

const PaymentActionCard = ({ Icon, title, description, workspaceId }: PaymentActionCardProps) => {
  const { mutate: openCustomerPortal } = useCustomerPortal(workspaceId)
  return (
    <div
      className="flex w-full cursor-pointer flex-col gap-4 rounded-lg border bg-neutral-50 p-4 transition-colors duration-300 hover:bg-neutral-100"
      onClick={() => {
        openCustomerPortal()
      }}
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <Icon />
        {title}
      </div>
      <div className="text-sm text-muted-foreground">{description}</div>
    </div>
  )
}
